<template>
	<label class="d21-plusminus">
		<button class="btn btn-plusminus" :disabled="disabled || haxMinValueReached">
			<i class="material-icons minus" style="margin-right:0rem;" @click="minus()">remove</i>
		</button>
		<input type="textbox" data-lpignore="true" readonly="readonly" v-model="inputVal" :disabled="disabled">
		<button class="btn btn-plusminus" :disabled="disabled || isPlusDisabled">
			<i class="material-icons plus" @click="plus()">add</i>
		</button>
	</label>
</template>

<script>
	export default {
		name: "d21-plusminus",
		props: ["value", "disabled", "minValue", "minSelect", "maxValue", "hasMaxValueReached"],
		data() {
			return {
				inputVal: this.value
			};
		},
		computed: {
			isPlusDisabled() {
				return this.hasMaxValueReached || this.inputVal >= this.maxValue;
			},
			haxMinValueReached() {
				return this.inputVal <= this.minValue;
			}
		},
		methods: {
			minus() {
				if (this.inputVal > 0 && (!this.minValue || this.inputVal > this.minValue)) this.inputVal--;
				if (this.minSelect && this.inputVal < this.minSelect) this.inputVal = 0;
			},
			plus() {
				if (this.inputVal < this.maxValue) this.inputVal++;
				if (this.minSelect && this.inputVal < this.minSelect) this.inputVal = this.minSelect;
			}
		},
		watch: {
			inputVal(val) {
				this.$emit("input", val);
			}
		},
	};
</script>